import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('trip');
const GET_TRIP = define('GET_TRIP', true);
const GET_APPROVED_TRIPS = define('GET_APPROVED_TRIPS', true);
const UPDATE_TRIP = define('UPDATE_TRIP', true);
const UPDATE_TRIP_KEYWORDS = define('UPDATE_TRIP_KEYWORDS', true);
const LOAD_DIFF_TRIP = define('LOAD_DIFF_TRIP', true);
const GET_LOGS = define('GET_LOGS', true);
const MANUAL_BOOKING = define('MANUAL_BOOKING', true);
const DUPLICATE_TRIP = define('DUPLICATE_TRIP', true);
const GET_SUBSTITUTABLE_LX = define('GET_SUBSTITUTABLE_LX', true);
const UPDATE_SUBSTITUTABLE_LX = define('UPDATE_SUBSTITUTABLE_LX', true);
const UPDATE_TRIP_RESTAURANT = define('UPDATE_TRIP_RESTAURANT', true);
const UPDATE_TRIP_SEASONAL = define('UPDATE_TRIP_SEASONAL', true);

const initialState = {
  isLoading: true,
  trip: {},
  isLoadingApprovedTrips: true,
  cityFlag: null,
  approvedTrips: [],
  diff: {},
  logs: [],
  isLoadingSubstitutableLx: true,
  recommendSubstitutableLxs: [],
  updating: false,
  isLoadingManualBook: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_APPROVED_TRIPS.PENDING:
      return {
        ...state,
        isLoadingApprovedTrips: true,
      };
    case GET_APPROVED_TRIPS.RESOLVED:
      return {
        ...state,
        isLoadingApprovedTrips: false,
        cityFlag: action.flag,
        approvedTrips: action.data,
      };
    case GET_TRIP.PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case GET_TRIP.RESOLVED:
      return {
        ...state,
        isLoading: false,
        trip: action.data
      };
    case LOAD_DIFF_TRIP.RESOLVED:
      return {
        ...state,
        diff: action.data
      };
    case GET_LOGS.RESOLVED:
      return {
        ...state,
        logs: action.data
      };
    case GET_SUBSTITUTABLE_LX.PENDING:
      return {
        ...state,
        isLoadingSubstitutableLx: true
      };
    case GET_SUBSTITUTABLE_LX.RESOLVED:
      return {
        ...state,
        isLoadingSubstitutableLx: false,
        recommendSubstitutableLxs: action.data
      };
    case UPDATE_TRIP_RESTAURANT.PENDING:
      return {
        ...state,
        updating: true
      };
    case UPDATE_TRIP_RESTAURANT.RESOLVED:
    case UPDATE_TRIP_RESTAURANT.REJECTED:
      return {
        ...state,
        updating: false
      };
    case MANUAL_BOOKING.PENDING:
      return {
        ...state,
        isLoadingManualBook: true
      };
    case MANUAL_BOOKING.RESOLVED:
    case MANUAL_BOOKING.REJECTED:
      return {
        ...state,
        isLoadingManualBook: false
      };
    default: return state;
  }
};

export const actions = {
  loadTrip: id => ({
    type: GET_TRIP,
    promise: api.get(`/trips/${id}`),
    error: 'Unable to load trip data'
  }),
  getApprovedTrips: (city, keywords, productType) => {
    const queryKeywords = keywords ? `&keywords=${keywords}` : '';
    const queryProductType = productType ? `&product_type=${productType}` : '';
    return {
      type: GET_APPROVED_TRIPS,
      flag: city,
      promise: api.get(`/trips/approved?city=${city}${queryKeywords}${queryProductType}`),
      error: 'Unable to load approved trips'
    };
  },
  searchApprovedTrip: (keywords, city) => ({
    type: GET_APPROVED_TRIPS,
    flag: city,
    promise: api.get(`/trips/approved?city=${city}&keywords=${keywords}`),
    error: 'Unable to load approved trips'
  }),
  updateTrip: (id, data = {}) => ({
    type: UPDATE_TRIP,
    promise: api.post(`/trips/${id}`, data),
    success: 'Trip data has been updated',
    error: 'Unable to update trip data'
  }),
  updateTripSeasonalPercentage: (data = {}) => ({
    type: UPDATE_TRIP_SEASONAL,
    promise: api.post('/trips/updateSeasonalPercentage', data),
    success: 'Trip seasonal percentage has been updated',
    error: 'Unable to update trip seasonal percentage'
  }),
  updateTripKeywords: (id, data = {}) => ({
    type: UPDATE_TRIP_KEYWORDS,
    promise: api.post(`/trips/updateKeywords/${id}`, data),
    success: 'Trip keywords has been updated',
    error: 'Unable to update trip keywords'
  }),
  loadDiffTrip: (originalId, resubmittedId) => ({
    type: LOAD_DIFF_TRIP,
    promise: api.get(`/trips/diff/${originalId}/${resubmittedId}`),
    error: 'Unable to load diff trip data'
  }),
  manualBooking: data => ({
    type: MANUAL_BOOKING,
    promise: api.post('/bookings/admin', data),
    success: 'Booking has been created',
    error: 'Unable to create booking'
  }),
  duplicateTrip: (tripId, lxId, isNotCopyOriginalId, isNotGenerateTrelloCard) => ({
    type: DUPLICATE_TRIP,
    promise: api.post(`/trips/${tripId}/duplicate`, {
      lx_id: lxId,
      is_not_copy_original_id: isNotCopyOriginalId,
      is_not_generate_trello_card: isNotGenerateTrelloCard
    }),
    success: 'Trip has been duplicated',
    error: 'Unable to duplicate trip'
  }),
  getLogs: (tripId) => ({
    type: GET_LOGS,
    promise: api.get(`/trips/${tripId}/logs`),
    error: 'Unable to trip logs'
  }),
  loadSubstitutableLx: (tripId) => ({
    type: GET_SUBSTITUTABLE_LX,
    promise: api.get(`/trips/${tripId}/substitutable-lx`)
  }),
  updateSubstitutableLx: (tripId, lxIds) => ({
    type: UPDATE_SUBSTITUTABLE_LX,
    promise: api.put(`/trips/${tripId}/substitutable-lx`, { lxIds }),
    success: 'Substitutable Lx has been updated',
    error: 'Unable to update substitutable lx',
  }),
  updateTripRestaurant: (tripId, restaurantIds) => ({
    type: UPDATE_TRIP_RESTAURANT,
    promise: api.put(`/trips/${tripId}/restaurant`, { restaurant_ids: restaurantIds }),
    success: 'Restaurant in Trip has been updated',
    error: 'Unable to update Restaurant in Trip',
  }),
};



// WEBPACK FOOTER //
// ./src/ducks/trip.js